import type { FC } from 'react';

import { EndStepCard, EndStepCardProps } from '@eneco/components/flow/EndStep/Card';
import { EndStepHero, EndStepHeroProps } from '@eneco/components/flow/EndStep/EndStepHero';

import { useMeterReadingsFlow } from '../../state/MeterReadingsFlow.machine';
import { SingleAmount } from '../components/SingleAmount';


interface Props extends EndStepCardProps, EndStepHeroProps {
  label: string;
}

export const Amount: FC<Props> = ({ heroImage, title, content, buttonHref, buttonText, label }) => {
  const { state } = useMeterReadingsFlow();
  const hasCheckoutAmount =
    state.context.save?.yearNoteSummary?.checkoutAmount && state.context.save?.yearNoteSummary?.checkoutAmount > 0;
  const checkoutAmountOrAdvancePayment = hasCheckoutAmount
    ? state.context.save?.yearNoteSummary?.checkoutAmount
    : state.context.save?.yearNoteSummary?.advancePaymentAmount;

  return (
    <EndStepHero heroImage={heroImage}>
      <EndStepCard title={title} content={content} buttonHref={buttonHref} buttonText={buttonText}>
        {state.context.save?.yearNoteSummary && <SingleAmount label={label} value={checkoutAmountOrAdvancePayment} />}
      </EndStepCard>
    </EndStepHero>
  );
};
